<template lang="pug">
ul.options-road-map
  li
    .circle(:class="{'full': step > 0}", @click="jumpToStep(0)")
    .stick(:class="{'full': step > 0}")
    div.option-value
      span.option-title Setup mode
      br
      a(@click="jumpToStep(0)", v-if="mode && step > 0") {{ mode | uppercase }}
      span.not-selected(v-else) -
  li
    .circle(:class="{'full': step > 1, 'not-clickable': step <= 1}", @click="jumpToStep(1)")
    .stick(:class="{'full': step > 1}")
    div.option-value
      span.option-title Mining hardware
      br
      a(@click="jumpToStep(1)", v-if="miningType && step > 1") {{ miningType | uppercase }}
      span.not-selected(v-else) -
  li(v-if="!(miningType === 'cpu' && step > 2)")
    .circle.hint--right(aria-label="Not needed on cpu mining", :class="{'full': step > 2, 'disabled': miningType === 'cpu' && step > 2, 'not-clickable': step <= 2}", @click="jumpToStep(2)")
    .stick(:class="{'full': step > 2, 'disabled': miningType === 'cpu' && step > 2}")
    div.option-value
      span.option-title Algorithm
      br
      a(@click="jumpToStep(2)", v-if="algorithm && algorithm.name  && step > 2") {{ algorithm.name | uppercase }}
      span.not-selected(v-else) -
  li
    .circle(:class="{'full': step > 3, 'not-clickable': step <= 3}", @click="jumpToStep(3)")
    .stick(:class="{'full': step > 3}")
    div.option-value
      span.option-title Coin
      br
      a.coin-selected(@click="jumpToStep(3)", v-if="coin && coin.symbol && step > 3")
        span {{ coin.symbol | uppercase }}
        img.coin-logo(:src="coin.logo", :alt="coin.symbol + ' logo'")
      span.not-selected(v-else) -
  li
    .circle(:class="{'full': step > 4, 'not-clickable': step <= 4}", @click="jumpToStep(4)")
    .stick(:class="{'full': step > 4}")
    div.option-value
      span.option-title Address
      br
      template(v-if="address && step > 4")
        a(@click="jumpToStep(4)") {{ trimmedAddress }}
      span.not-selected(v-else) -
  li(v-if="!(mode === 'basic' && step > 0)")
    .circle.hint--right(aria-label="Not needed on basic mode", :class="{'full': step > 5, 'disabled': mode === 'basic' && step > 0, 'not-clickable': step <= 5}", @click="jumpToStep(5)")
    .stick(:class="{'full': step > 5, 'disabled': mode === 'basic' && step > 0}")
    div.option-value
      span.option-title Region
      br
      a.region-container(@click="jumpToStep(5)", v-if="region && region.description && step > 5") 
        span {{ region.description | uppercase }}
        img.region-image(v-if="region.country", :src="'/img/region/' + region.country + '.png'")
      span.not-selected(v-else) -
  li(v-if="!(mode === 'basic' && step > 0)")
    .circle.hint--right(aria-label="Not needed on basic mode", :class="{'full': step > 6, 'disabled': mode === 'basic' && step > 0, 'not-clickable': step <= 6}", @click="jumpToStep(6)")
    .stick(:class="{'full': step > 6, 'disabled': mode === 'basic' && step > 0}")
    div.option-value
      span.option-title Port
      br
      a(@click="jumpToStep(6)", v-if="port && port.number && step > 6") {{ port.number | uppercase }}
      span.not-selected(v-else) -
  li(v-if="!(mode === 'basic' && step > 0)")
    .circle.hint--right(aria-label="Not needed on basic mode", :class="{'full': step > 7, 'disabled': mode === 'basic' && step > 0, 'not-clickable': step <= 7}", @click="jumpToStep(7)")
    .stick(:class="{'full': step > 7, 'disabled': mode === 'basic' && step > 0}")
    div.option-value
      span.option-title Worker
      br
      template(v-if="worker && step > 7")
        a(@click="jumpToStep(7)", v-if="worker.length > 15") {{  worker.substring(0,15) + '...' }}
        a(@click="jumpToStep(7)", v-else) {{ worker }}
      span.not-selected(v-else) -
  li
    .circle(:class="{'full': step > 8, 'not-clickable': step <= 8}", @click="jumpToStep(8)")
    div.option-value
      span.option-title Referral
      br
      a(@click="jumpToStep(8)", v-if="referralCode && step > 8") {{ referralCode }}
      span.not-selected.cursor-pointer(@click="jumpToStep(8)", v-else) -
    
</template>

<script>
export default {
  name: 'c_road_map',
  props: ['step', 'mode', 'miningType', 'algorithm', 'coin', 'address', 'region', 'port', 'worker', 'referralCode'],
  data () {
    return {
    }
  },
  computed : {
    trimmedAddress () {
      let vm = this
      if (vm.address.length > 23) {
        let numberOfChars = 9
        return vm.address.substring(0, numberOfChars) + '...' + vm.address.substring(vm.address.length - numberOfChars, vm.address.length)
      } else return vm.address
    }
  },
  methods : {
    jumpToStep (step) {
      let vm = this
      if (vm.step > step) {
        vm.$emit('jumpToStep', step)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.options-road-map
  font-size: 12px
  text-align left
  display flex
  flex-direction column
  margin 0px auto
  li
    display flex
    align-items center
    padding 2px 0px
    position relative
  .option-value
    overflow-x hidden
    a
      font-weight: 700;
      font-size: 15px;
      color: #000;
    .not-selected
      color: #ccc
      font-weight: 700;
      font-size: 15px;
    .coin-selected
      display flex
      align-items center
      .coin-logo
        margin-left 5px
        width 22px
        height 22px
    .region-container
      display flex
      align-items center
      .region-image
        margin-left 5px
        height 12px
      
  .option-title
    font-size 10px
    font-weight 400
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 1px;
  .circle
    margin-right 5px
    display: inline-block;
    min-width: 12px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-left: 4px;
    margin-right: 15px;
    cursor: pointer;
    border 1px solid #b6ffb6
    &.full
      background: #b6ffb6;
    &.disabled
      background: #ccc
      border 1px solid #ccc
  .stick
    position: absolute;
    top: 27px;
    left: 9px;
    border: 1px solid #def5de;
    border-top 0px
    border-bottom 0px
    width: 2px;
    height: 34px;
    &.full
      background: #b6ffb6;
      border: 1px solid #b6ffb6;
    &.disabled
      background: #ccc
      border 1px solid #ccc

.not-clickable
  cursor: initial !important

html.dark, body.dark
  .option-value
    color #fff
    a
      color: #fff;
    .not-selected
      color: #4c4c4c
      
@media (max-width: 768px)
  .options-road-map
      display none
  
</style>



// WEBPACK FOOTER //
// c_road_map.vue?4c8bdb4f